// extracted by mini-css-extract-plugin
module.exports = {"root":"_3VOaB","container":"_2rMv1","title":"_1gaY_","icon":"_2qqKH"};